<template>
  <div class='hs-number-input'>
    <el-input v-model.number="modelValue" @keyup.native="handleKeyup" @input.native='handleInput' @change="handleChange"></el-input>
  </div>
</template>

<script>
export default {
  name:'HsNumberInput',
  props: {
    value: {
      type: Number,
      default: null
    },
    placeholder:{
      type:String,
      default:''
    },
    max:{
      type:Number,
      default:null
    },
    min:{
      type:Number,
      default:null
    },
    size:{
      type:String,
      default:'small'
    },
    canBeZero:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      modelValue: this.value
    }
  },
  watch: {
    value (v) {
      this.modelValue = v
    }
  },
  methods: {
    handleKeyup() {
      let value= this.modelValue;
      if (typeof value === 'string') {
        let data='';
        const patMustNumber = /\D/g;
        if(this.canBeZero){
          data = this.modelValue.replace(patMustNumber,'');
        }else{
          const patNotStartZero = /^0+/g;
          data = value.replace(patNotStartZero, '').replace(patMustNumber, '');
        }
        value=data;
      }
      if(this.max){
        if(Number(value)>this.max)value=this.max;
      }
      if(this.min){
        if(Number(value)<this.min)value=this.min;
      }
      this.modelValue = value === '' ? null : value;
    },
    handleInput () {
      this.handleKeyup()
      this.$emit('input', this.modelValue)
    },
    handleChange () {
      this.handleKeyup()
      this.$emit('change', this.modelValue)
    }
  },
}
</script>

<style lang="scss" scoped>

</style>